import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import Button from './Button';

interface props {
  onClick: () => void;
  disabled: boolean;
}

const ClearFilterButton = ({ onClick, disabled }: props) => {
  const { t } = useTranslation();
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={disabled ? '!bg-transparent' : ''}
      endIcon={<FontAwesomeIcon icon={faCircleXmark} />}
      color="transparent"
    >
      {t('Clear Filters')}
    </Button>
  );
};
export default ClearFilterButton;
